import { ButtonInput } from './button-input';

export default ButtonInput;
